/* Legal content accordion — mockup-exact behaviour.
   - Clicking a policy header toggles its panel (aria-expanded + .legal-block--open).
   - Clicking a table-of-contents link opens the target block and smooth-scrolls to it.
   Delegated + idempotent so it survives Theme Editor section re-renders. */
(function () {
  'use strict';

  function toggleBlock(block, open) {
    var btn = block.querySelector('.legal-block__btn');
    var willOpen = typeof open === 'boolean' ? open : !block.classList.contains('legal-block--open');
    block.classList.toggle('legal-block--open', willOpen);
    if (btn) {
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }
  }

  function onClick(event) {
    var link = event.target.closest('.legal-toc__link');
    if (link) {
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1) {
        var target = document.getElementById(href.slice(1));
        if (target && target.classList.contains('legal-block')) {
          event.preventDefault();
          toggleBlock(target, true);
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      return;
    }

    var btn = event.target.closest('.legal-block__btn');
    if (btn) {
      var block = btn.closest('.legal-block');
      if (block) {
        toggleBlock(block);
      }
    }
  }

  function init() {
    if (window.__legalContentInit) {
      return;
    }
    window.__legalContentInit = true;
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind is a no-op thanks to the guard, but keep the listener alive across editor events.
  document.addEventListener('shopify:section:load', init);
})();
